import { AntDesign } from "@expo/vector-icons";
import React from "react";
import { Pressable, Text, View } from "react-native";

interface CardDocumentProps {
  id: string;
  layer2Id: string;
  text: string;
  url: string;
}

export default function CardDocument(props: CardDocumentProps) {
  const redirecUrl = `https://management.layer2financial.com/applications/${props.layer2Id}`;

  return (
    <Pressable
      className="bg-white1 items-center flex-col border border-lightgray w-56 h-fit rounded-lg p-4 m-4 shadow hover:shadow-md"
      onPress={() => window.open(redirecUrl, "_blank", "noopener noreferrer")}
    >
      <AntDesign name="file1" size={36} className="text-midgray" />
      <Text
        numberOfLines={1}
        ellipsizeMode="tail"
        className="text-base text-center text-midgray mt-2"
      >
        {props.text}
      </Text>
    </Pressable>
  );
}
